import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Footer, Header, ShareBlock } from "../../components";
import {
    buildShareMessage,
    buildShareUrl,
    buildSmsUrl,
    detectMobilePlatform,
    parseShareChannel,
} from "../../utils/share";
import styles from "./share.module.css";

/**
 * Landing page for the Customer.io "Fais passer le mot" email buttons.
 * Public: the sender may be logged out and the recipient isn't a patient yet.
 */
const SharePage: React.FunctionComponent = () => {
    const { search } = useLocation();
    const via = parseShareChannel(new URLSearchParams(search).get("via"));

    // Effects

    useEffect(() => {
        // sms: can be opened without a user gesture; clipboard/share can't, so
        // via=copy only emphasizes the button.
        if (via !== "sms") return;
        const platform = detectMobilePlatform(
            navigator.userAgent,
            navigator.maxTouchPoints
        );
        if (platform) {
            window.location.href = buildSmsUrl(
                platform,
                buildShareMessage(buildShareUrl("sms"))
            );
        }
    }, [via]);

    // Rendering

    return (
        <div className="page">
            <Header />
            <main className={styles.container}>
                <ShareBlock emphasizedChannel={via} />
            </main>
            <Footer />
        </div>
    );
};

export default SharePage;
